import { fetchBackend } from '@/utils/fetch'

/**
 * 获取当前用户的菜单配置
 */
export const getMenuList = () => fetchBackend.get('/pe/powerpro/node/api/v1/menu/config', {})
